module.exports = __webpack_public_path__ + "app/referentials/referential-config/referential-reduced-section-3BHqeLz4.html";